import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DaterangepickerModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  SharedModule,
  AutocompleteModule,
  ComboModule,
  InputModule,
} from 'beyond-util';
import { GlinkMaska16Component } from './glink-maska-16.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    SharedModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    NgxSpinnerModule,
  ],
  declarations: [GlinkMaska16Component],
  exports: [GlinkMaska16Component],
  entryComponents: [GlinkMaska16Component],
})
export class GlinkMaska16Module {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/glink-maska-16/glink-maska-16.module.ts